import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

interface IConfig extends AxiosRequestConfig {
  public?: boolean;
}

class CodealoCoursesService {
  private instance: AxiosInstance;
  private bearerToken: string;

  constructor() {
    this.instance = axios.create({
      baseURL: process.env.NEXT_PUBLIC_COURSE_SERVICE_URL
    });
    this.instance.interceptors.request.use(this.addEnv);
    this.instance.interceptors.request.use(this.addAuthHeader);
  }

  getInstance = () => this.instance;

  setBearerToken = (token: string) => (this.bearerToken = token);

  addEnv = (config: IConfig) => {
    config.params = {...config.params, env: process.env.NEXT_PUBLIC_ENV};
    return config;
  }

  addAuthHeader = (config: IConfig) => {
    if (this.bearerToken && !config.public)
      config.headers.Authorization = `Bearer ${this.bearerToken}`;
    delete config.public;
    return config;
  };
}

const codealoCourseService = new CodealoCoursesService();

export { codealoCourseService };